/**
 * Single source of truth for role labels + tones across the user surface.
 * Used by UserList, UserSlideOver, KpiTile tints, and Register screens.
 */
export const ROLE_OPTIONS = [
  {value: "CLIENT_ADMIN", label: "Admin", short: "ADM"},
  {value: "CLIENT_MANAGER", label: "Manager", short: "MGR"},
  {value: "CLIENT_EMPLOYEE", label: "Employee", short: "EMP"},
  {value: "MOBI_TRACK", label: "Track Point", short: "TP"},
];

/**
 * Roles that can be ASSIGNED to a user via the generic create/edit/bulk-import paths (the
 * registerUser/editUser endpoints). MOBI_TRACK is deliberately excluded: those endpoints have no
 * asset-linking logic, so picking it there creates a login with no linked ClientAsset — invisible
 * on the Track Point dashboard/device list/live tracking, with nothing for its location posts to
 * attach to. The backend rejects it outright as a backstop, but the picker shouldn't offer it in
 * the first place. New Track Point drivers must go through Assets -> Register Asset -> MOBI_TRACK,
 * which creates the asset and the linked login atomically.
 *
 * ROLE_OPTIONS (the full list, MOBI_TRACK included) stays the one to use for anything that reads
 * roles rather than assigns one — the "All roles" filter, role pills/labels, etc. — since existing
 * Track Point users still need to show up and be filterable there.
 */
export const ASSIGNABLE_ROLE_OPTIONS = ROLE_OPTIONS.filter((r) => r.value !== "MOBI_TRACK");

export const ROLE_LABELS = {
  SUPER_ADMIN: "Super Admin",
  CLIENT_ADMIN: "Admin",
  CLIENT_MANAGER: "Manager",
  CLIENT_EMPLOYEE: "Employee",
  MOBI_TRACK: "Track Point",
};

export const ROLE_TONE = {
  SUPER_ADMIN: "brand",
  CLIENT_ADMIN: "info",
  CLIENT_MANAGER: "warning",
  CLIENT_EMPLOYEE: "neutral",
  MOBI_TRACK: "success",
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || role || "—";
}

export function isSuspended(user) {
  const s = (user?.userStatus || "").toLowerCase();
  return s === "suspended" || s === "inactive";
}
